import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/landing/primitives";
import { FAQS } from "@/data/content";

export default function FAQ() {
  const [open, setOpen] = useState(0);
  return (
    <section id="faq" className="relative py-20 md:py-28 scroll-mt-24" data-testid="section-faq">
      <div className="container-trt">
        <SectionHeading eyebrow="FAQ" title="Questions," highlight="answered" />
        <div className="mt-14 max-w-3xl mx-auto flex flex-col gap-3">
          {FAQS.map((f, i) => {
            const isOpen = open === i;
            return (
              <Reveal key={i} delay={i * 0.05}>
                <div className={`rounded-2xl overflow-hidden ${isOpen ? "glass-gold" : "glass"} card-hover`} data-testid={`faq-item-${i}`}>
                  <button
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    className="w-full flex items-center justify-between gap-4 p-5 text-left"
                    data-testid={`faq-toggle-${i}`}
                  >
                    <span className="font-display font-bold text-base md:text-lg">{f.q}</span>
                    <motion.span animate={{ rotate: isOpen ? 45 : 0 }} className="shrink-0">
                      <Plus className="w-5 h-5 text-[var(--gold-2)]" />
                    </motion.span>
                  </button>
                  <AnimatePresence initial={false}>
                    {isOpen && (
                      <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.3 }}
                        className="overflow-hidden"
                      >
                        <p className="px-5 pb-5 text-[var(--muted)] leading-relaxed text-sm">{f.a}</p>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
